import {default as DataGrid} from './LocalizedDataGrid';
import { useTranslation } from "react-i18next";
import moment from 'moment-timezone';

const RecentEventList = (props) => {

    const {events, localTimezone} = props;

    const { t } = useTranslation();

    const columns = [
        { 
            field: 'timestamp', 
            headerName: t('Time'), 
            flex: 1,
            minWidth: 80,
            valueFormatter: (params) => {
                return moment.utc(params.value).tz(localTimezone).format("D MMM HH:mm");
            }
        },
        { field: 'identifier', headerName: t('ID'), flex:1, minWidth: 80},
        { field: 'location', headerName: t('Location'), flex:1, minWidth: 80},
        { field: 'system', headerName: t('System'), flex:1, minWidth: 80},
        { field: 'name', headerName: t('Device'), flex:1, minWidth: 80},
        { field: 'value', headerName: t('Update'), flex:1, minWidth: 80},
        { field: 'status', headerName: t('Status'), flex:1, minWidth: 80}
      ];

      return (
        <DataGrid 
            columns={columns}
            rows={events}
            initialState={{
                sorting: {
                  sortModel: [{ field: 'timestamp', sort: 'desc' }],
                },
              }}
            hideFooter
            getRowId={(row)=>row.url}
        />
    )
}
export default RecentEventList;